import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const DeleteIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentcolor">
            {/* eslint-disable-next-line max-len */}
            <path d="M5.00008 16.6667V5.00001H4.16675V4.16668H7.50008V3.52563H12.5001V4.16668H15.8334V5.00001H15.0001V16.6667H5.00008ZM5.83341 15.8333H14.1667V5.00001H5.83341V15.8333ZM8.17321 14.1667H9.00654V6.66668H8.17321V14.1667ZM10.9936 14.1667H11.827V6.66668H10.9936V14.1667Z"/>
        </svg>
    </IconWrapper>
));
